/************************************** AMBIENTE TESTE GERAL ************************************/

/*
export const environment = {
  production: true
};

export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemtesteback.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemtesteback.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemtesteback.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemtesteback.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemtesteback.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemtesterpt.herasuporte.com',
  accountApiV1: 'https://sigemtesterpt.herasuporte.com/v1'
};


export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'EMPRESA TESTE S.CLOUD',   // Teste genérico
  parceiroComercial: 'Implantando Soluções!',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: true,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: procure o <b>gestor do sistema</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: false, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: false,
  AtualizaMaterialValor: 2, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Elemento Organizacional', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: true, // se true, campo Localizacao em Cadastrar SS é obrigatório
};
*/

/************************************** AMBIENTE MARCILIO DIAS ************************************/

/*
export const environment = {
  production: true
};

export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemmdiasback.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemmdiasback.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemmdiasback.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemmdiasback.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemmdiasback.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemmdiasrpt.herasuporte.com',
  accountApiV1: 'https://sigemmdiasrpt.herasuporte.com/v1'
};

export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'MARCÍLIO DIAS',   // Porto de santos
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: true,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: procure o <b>gestor do sistema</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: true, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: true,
  AtualizaMaterialValor: 2, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Elemento Organizacional', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: true, // se true, campo Localizacao em Cadastrar SS é obrigatório
};
*/

/************************************** AMBIENTE CMB PRODUCAO ************************************/


export const environment = {
  production: true
};


export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemcmb25back.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemcmb25back.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemcmb25back.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemcmb25back.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemcmb25back.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemcmb25rpt.herasuporte.com',
  accountApiV1: 'https://sigemcmb25rpt.herasuporte.com/v1'
};

export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'DEMAN - CMB CT2078',   // deman cmb NOVO CONTRATO DEZ-25
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: false,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: ligue para o <b>ramal 2484</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: false, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: true,
  AtualizaMaterialValor: 1, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Centro de Custo', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: false, // se true, campo Localizacao em Cadastrar SS é obrigatório
 };



/************************************** AMBIENTE CMB TESTE ************************************/
/*
export const environment = {
  production: true
};

export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemcmbbackdev.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemcmbbackdev.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemcmbbackdev.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemcmbbackdev.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemcmbbackdev.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemcmbrptdev.herasuporte.com',
  accountApiV1: 'https://sigemcmbrptdev.herasuporte.com/v1'
};

export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'TESTE - CMB',   // deman cmb
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: true,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: ligue para o <b>ramal 2484</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: false, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: false,
  AtualizaMaterialValor: 1, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Centro de Custo', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: false, // se true, campo Localizacao em Cadastrar SS é obrigatório
};
*/

/************************************** AMBIENTE CMB ANTES - Ambinte Histórico ************************************/

/*
export const environment = {
  production: true
};


export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemcmbback.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemcmbback.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemcmbback.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemcmbback.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemcmbback.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemcmbrpt.herasuporte.com',
  accountApiV1: 'https://sigemcmbrpt.herasuporte.com/v1'
};

export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'DEMAN - CMB',   // deman cmb
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: false,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: ligue para o <b>ramal 2484</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: false, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: true,
  AtualizaMaterialValor: 1, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Centro de Custo', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: false, // se true, campo Localizacao em Cadastrar SS é obrigatório
 };
*/


/************************************** AMBIENTE CARDOSO FONTES PRODUCAO ************************************/

/*
export const environment = {
  production: true
};

export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemhfcfback.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemhfcfback.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemhfcfback.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemhfcfback.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemhfcfback.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemhfcfrpt.herasuporte.com',
  accountApiV1: 'https://sigemhfcfrpt.herasuporte.com/v1'
};

export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'HOSPITAL FEDERAL CARDOSO FONTES',   // deman cmb
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: false,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: procure o <b>gestor do sistema</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: true, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: true,
  AtualizaMaterialValor: 1, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Centro de Custo', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: false, // se true, campo Localizacao em Cadastrar SS é obrigatório
};
*/

/************************************** AMBIENTE PORTO DE SANTOS ************************************/

/*
export const environment = {
  production: true
};

export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigempsantosback.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigempsantosback.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigempsantosback.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigempsantosback.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigempsantosback.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigempsantosrpt.herasuporte.com',
  accountApiV1: 'https://sigempsantosrpt.herasuporte.com/v1'
};

export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'PORTO DE SANTOS',   // Porto de santos
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: true,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: procure o <b>gestor do sistema</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: true, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: false,
  AtualizaMaterialValor: 1, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Centro de Custo', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: false, // se true, campo Localizacao em Cadastrar SS é obrigatório
};
*/


/************************************** AMBIENTE TSE ************************************/

/*
export const environment = {
  production: true
};

export const SCAMP_API = {
  production: true,
  accountApiV1: 'https://sigemtseback.herasuporte.com/v1',
  pathDownloadPhoto: 'https://sigemtseback.herasuporte.com/Uploads/ImagemOrdemServico',
  pathDownloadExcel: 'https://sigemtseback.herasuporte.com/Uploads/ArquivosExcel',
  pathUploadFiles: 'https://sigemtseback.herasuporte.com/Uploads/Arquivos',
  pathDownloadQrCode: 'https://sigemtseback.herasuporte.com/Uploads/Qrcode'
};

export const SCAMP_API_RPT = {
  production: true,
  root: 'https://sigemtserpt.herasuporte.com',
  accountApiV1: 'https://sigemtserpt.herasuporte.com/v1'
};


export const APP_SETTINGS = {
  tipoInstalacao: 'SSPT', // SS | PT | SSPT
  nomeCliente: 'TSE',   // Teste genérico
  parceiroComercial: 'Parceria IC Supply',
  tipoLocal: 2, // (1) Predio, (2) Subestacao, (3) ViraCopos
  appName: 'SIGEM CLOUD',
  tamanhoLimiteUploadArquivo: 3, // MB
  tipoEquipamentoPadrao : 1, // Id da tabela TipoDeEquipamento que define o tipo padrão
  exibirQuadroFalhasEmDashboard: true,    // define se o quadro de falhas aparece no Dashboard
  msgTelaLogin: 'Para criar nova senha: procure o <b>gestor do sistema</b>',
  nomeManualSistema: 'manual.pdf',
  prioridadeDefaultOSPreventiva: 1, // (1) Imediata, (2) Máximo 72 horas, (3) Sem prioridade
  proxExecFinalSemana: false, // se true, próxima execução salta o sábado e domingo
  requeridoRamalCentroCusto: false,
  AtualizaMaterialValor: 2, //  (1) Somente via digitação  (2) Digitando e a cada novo preço médio
  numeroUltimasEntradasAExibir: 10, // aplicável em Grid Tela Entrada Material
  LabelCentroCusto: 'Elemento Organizacional', // Centro de Custo, Elemento Organizacional
  requeridoLocalizacao: true, // se true, campo Localizacao em Cadastrar SS é obrigatório
};
*/

